module.exports = __webpack_public_path__ + "img/firma.a69d5aaf.png";